import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-helper-text',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './helper-text.component.html',
})
export class HelperTextComponent {
  helperText = input<string>('');
}
